import { render } from "./NewTargetModal.vue?vue&type=template&id=1e91f962&ts=true"
import script from "./NewTargetModal.vue?vue&type=script&lang=ts"
export * from "./NewTargetModal.vue?vue&type=script&lang=ts"

import "./NewTargetModal.vue?vue&type=style&index=0&id=1e91f962&lang=scss"

import exportComponent from "/home/starkoms/webapps/front-comm-starkoms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__